export const MobileHeader = ({ title }) => {
  const openMobileMenu = () => {
    const menu = document.querySelector('.dash-mobile-menu-con');
    const backgroundOverlay = document.querySelector('.background-overlay');
    menu.classList.add('active');
    backgroundOverlay.classList.add('active');
  };

  return (
    <div className='dash-header-con'>
      <div className='dash-hamburger' onClick={openMobileMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className='dash-header-txt-con'>
        <div className='dash-header-txt'>
          <p>{title.substr(0, 1).toUpperCase() + title.substr(1)} Stats</p>
          <div className='stats-icon'>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};
